<pw-view-title>
  {{ (task$ | async)?.TEXT }}
</pw-view-title>

<div class="mw-70">
  <mat-stepper #stepper>

    <mat-step>
      <ng-template matStepLabel>Ressourcenauswahl</ng-template>

      <div class="stepper-container">
        <div style="padding: 1rem">
          <mat-form-field>
            <mat-label>Ressource</mat-label>
            <mat-select [(value)]="selectedRes" [compareWith]="compareRes">
              <mat-option *ngFor="let res of resources$ | async" [value]="res">
                {{ res.TEXT }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="nav-buttons">
          <button mat-raised-button color="accent" (click)="stepper.next()">WEITER</button>
        </div>
      </div>
    </mat-step>

    <ng-container *ngIf="selectedRes">
      <mat-step>
        <ng-template matStepLabel>Modusauswahl</ng-template>

        <div class="stepper-container">
          <div style="padding: 1rem">
            <mat-radio-group [(ngModel)]="selectedBookingMode">
              <mat-radio-button [value]="'EMPLOYEE'">Mitarbeiter</mat-radio-button>
              <!--<mat-radio-button [value]="'MACHINE'">Maschine</mat-radio-button>-->
              <mat-radio-button [value]="'EMPLOYEEANDMACHINE'" *ngIf="selectedRes.MACHINE_BOOKING_MANUAL">Mitarbeiter &
                Maschine
              </mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="nav-buttons">
            <button mat-raised-button color="accent" (click)="stepper.previous()">ZURÜCK</button>
            <button mat-raised-button color="accent" (click)="stepper.next()">WEITER</button>
          </div>
        </div>
      </mat-step>

    </ng-container>

    <mat-step>
      <ng-template matStepLabel>Aktive Buchung</ng-template>

      <div class="info-hint" style="margin-top: 1rem; margin-bottom: 1rem">
        <mat-icon>info</mat-icon>
        <span style="padding: 0.2rem;">Es werden die aufgelisteten aktiven Buchungen abgeschlossen.</span>
      </div>

      <div class="stepper-container">
        <ng-container
          *ngIf="(currentTracking$ | async)?.OBJECT_ID || (currentMachineTracking$ | async)?.OBJECT_ID; else noActiveTrackings">
          <div class="active-trackings-container">
            <ng-container *ngIf="currentTracking$ | async as currentTracking">
              <p4m-active-tracking [tracking]="currentTracking"></p4m-active-tracking>
            </ng-container>

            <ng-container *ngIf="currentMachineTracking$ | async as currentTracking">
              <p4m-active-tracking [tracking]="currentTracking"
                                   (machineWorkingTimeChanged)="onMachineWorkingtimeChanged($event)"></p4m-active-tracking>
            </ng-container>
          </div>
        </ng-container>
        <ng-template #noActiveTrackings>
          <div>Keine aktiven Buchungen vorhanden.</div>
        </ng-template>

        <div class="nav-buttons">
          <button mat-raised-button color="accent" (click)="stepper.previous()">ZURÜCK</button>
          <button mat-raised-button color="accent" (click)="stepper.next()">WEITER</button>
        </div>
      </div>

    </mat-step>

    <mat-step>
      <ng-template matStepLabel>Vervollständigung</ng-template>

      <div class="active-trackings-container">
        <p4m-complete-tracking
          *ngIf="selectedBookingMode === 'EMPLOYEE' || selectedBookingMode === 'EMPLOYEEANDMACHINE'"
          [servicesTypes$]="serviceTypes$" [ratingTypes$]="ratingTypes$"
          (trackingChanged)="onEmployeeTrackingChanged($event)"></p4m-complete-tracking>
        <p4m-complete-tracking
          *ngIf="selectedBookingMode === 'EMPLOYEEANDMACHINE' || selectedBookingMode === 'MACHINE' "
          [isEmployee]="false" [servicesTypes$]="serviceTypes$"
          [ratingTypes$]="ratingTypes$"
          (trackingChanged)="onMachineTrackingChanged($event)"></p4m-complete-tracking>

        <mat-form-field>
          <input matInput placeholder="Kommentar" [(ngModel)]="comment">
        </mat-form-field>

        <div class="nav-buttons">
          <button mat-raised-button color="accent" (click)="stepper.previous()">ZURÜCK</button>
          <button style="justify-self: end; align-self: end;" color="accent" mat-raised-button
                  (click)="startTracking()">
            STARTEN
          </button>
        </div>


      </div>

    </mat-step>

  </mat-stepper>
</div>
